<script>
import ScheduledServiceTimeForm from '@views/jobs/scheduledServiceTimes/scheduled-service-time-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    ScheduledServiceTimeForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    job: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(scheduledServiceTime) {
      this.setUnchanged();
      this.$emit('updated', scheduledServiceTime);
    },
    remove() {
      this.setUnchanged();
      this.$emit('deleted');
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.scheduledServiceTimeModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal
    ref="scheduledServiceTimeModal"
    v-model="showModal"
    size="lg"
    hide-footer
    :title="$t('titles.edit_scheduled_service_time')"
    static
    @hide="hide"
    @hidden="$emit('hidden')"
  >
    <ScheduledServiceTimeForm v-if="showModal" :loaded-id="loadedId" :job="job" @submitted="submit" @deleted="remove" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
